var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertiClipPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 833,
    height: 51,
    viewBox: "0 0 833 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M832.999 0L803.831 25.5L832.999 51H0L29.1686 25.5L0 0H832.999Z",
    fill: "url(#paint0_linear_9520_4686)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9520_4686",
    x1: -265,
    y1: -802,
    x2: 719,
    y2: 974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43ADE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518537,
    stopColor: "#43ADE8",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589213,
    stopColor: "#EE6C01",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertiClipPath);
export default __webpack_public_path__ + "static/media/certi-clip-path.4945777a9d465b905d84022bce97eade.svg";
export { ForwardRef as ReactComponent };